import request from '@/utils/request';
import { findConfigDetails } from '@/api/setting/config';
import { getSystemTime } from '@/api/setting/other';

const baseURL = '/userapi/user/'

export const login = data =>
  request({
    data,
    url: `${baseURL}login`,
    method: 'post'
  });

export const getLoginDate = () => {
  return new Date(localStorage.getItem('loginDate'))
}

export const setLoginDate = async (loginDate) => {
  localStorage.setItem('loginDate', loginDate);
}

export const getSelectableMonth = async () => {
  const response = await request({
    url: `/financeapi/finance/home/getPeriodList`,
    method: 'get',
    params: { format: 'yyyy-MM' }
  });
  return response.data.list.map(i => {
    let segments = i.split('-');
    return {
      label: segments[0] + '年' + segments[1] + '月',
      value: i,
      seasonLabel: segments[0] + '年第' + Math.ceil(segments[1] / 3) + '季度',
      seasonValue: segments[0] + '-0' + Math.ceil(segments[1] / 3)
    }
  });
}

export const getSelectableMonthToNow = async () => {
  // 获取启用日期
  const response1 = await findConfigDetails();
  const beginDate = new Date(response1.data.beginDate);
  let beginYear = beginDate.getFullYear();
  let beginMouth = beginDate.getMonth() + 1;
  // 获取系统服务器日期
  const response2 = await getSystemTime();
  const nowDate = new Date(response2.data.systemTime);
  const nowYear = nowDate.getFullYear();
  const nowMouth = nowDate.getMonth() + 1;
  // 计算可选日期范围
  const selectableDate = [];
  while (
    beginYear < nowYear ||
    (beginYear === nowYear && beginMouth <= nowMouth)
  ) {
    let strMouth = beginMouth.toString();
    if (strMouth.length === 1) {
      strMouth = '0' + strMouth;
    }
    selectableDate.push({
      label: beginYear + '年' + strMouth + '月',
      value: beginYear + '-' + strMouth,
      seasonLabel: beginYear + '年第' + Math.ceil(beginMouth / 3) + '季度',
      seasonValue: beginYear + '-0' + Math.ceil(beginMouth / 3)
    });
    beginMouth++;
    if (beginMouth === 13) {
      beginYear++;
      beginMouth = 1;
    }
  }
  return selectableDate;
}

export const logout = data =>
  request({
    data,
    url: `${baseURL}logout`,
    method: 'post'
  });

export const registry = data =>
  request({
    data,
    url: `${baseURL}registry`,
    method: 'post'
  });

export const findUserByName = data =>
  request({
    data,
    url: `${baseURL}findUserByName`,
    method: 'post'
  });

export const checkToken = data =>
  request({
    data,
    url: `${baseURL}checkToken`,
    method: 'post'
  });

export const deleteUser = data =>
  request({
    data,
    url: `${baseURL}deleteUser`,
    method: 'post'
  });

export const modifyUser = data =>
  request({
    data,
    url: `${baseURL}modifyUser`,
    method: 'post'
  });

export const findRoleByName = data =>
  request({
    data,
    url: `${baseURL}findRoleByName`,
    method: 'post'
  });

export const addRole = data =>
  request({
    data,
    url: `${baseURL}addRole`,
    method: 'post'
  });

export const deleteRole = data =>
  request({
    data,
    url: `${baseURL}deleteRole`,
    method: 'post'
  });

export const modifyRole = data =>
  request({
    data,
    url: `${baseURL}modifyRole`,
    method: 'post'
  });

export const findAllAuthority = data =>
  request({
    data,
    url: `${baseURL}findAllAuthority`,
    method: 'post'
  });

export const findRoleAuthrity = data =>
  request({
    data,
    url: `${baseURL}findRoleAuthrity`,
    method: 'post'
  });

export const allotAuthority2Role = data =>
  request({
    data,
    url: `${baseURL}allotAuthority2Role`,
    method: 'post'
  });

